import React from 'react';
import './HealthSpanCardLoader.scss';

const HealthSpanCardLoader = () => {
  return (
    <div className="health-span-card-loader">
      <div className="skeleton-card-container">
        <div className="skeleton-card-block skeleton"></div>
      </div>
    </div>
  );
};

export default HealthSpanCardLoader;
